import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from '@auth0/auth0-angular';
import { ErrorComponent } from './error/error.component';
import { IsProductionTeamMemberGuard } from './util/guards/is-production-team-member.guard';
import { environment as env } from '../environments/environment';
import { PageM30Component } from './m30/page-m30/page-m30.component';
import { AboutComponent } from './about/about.component';
import { PageMyM30Component } from './m30/page-my-m30/page-my-m30.component';

const routes: Routes = [
  {
    path: 'my',
    canActivateChild: [
      AuthGuard,
    ],
    children: [
      {
        path: 'm30',
        component: PageMyM30Component,
        title: env.htmlTitlePrefix + 'Start Form',
      },
    ],
  },
  {
    path: 'report',
    canActivateChild: [
      AuthGuard,
    ],
    children: [
      {
        path: 'm30',
        component: PageM30Component,
        title: env.htmlTitlePrefix + 'OT&TA Grand Total',
      },
    ],
  },
  {
    path: 'admin',
    canActivateChild: [
      AuthGuard,
      IsProductionTeamMemberGuard,
    ],
    children: [
    ],
  },
  {
    path: 'error/:msg',
    component: ErrorComponent,
    canActivate: [AuthGuard],  // Protect a route by registering the auth guard in the `canActivate` hook
    title: env.htmlTitlePrefix + 'Error',
  },
  {
    path: 'about',
    component: AboutComponent,
    title: 'CrewTime',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
